export default "__VITE_ASSET__SxzlMXhG__";